import styles from './FeatureBlock.module.css';

const FeatureBlock = ({
    link,
    linkText,
    title,
    description,
    icon,
    backgroundColor = "#fff",
    color = "#282828"
}) => {
    return (
        <div className={styles.featureBlock} style={{
            backgroundColor,
            color
        }}>
            <div className={styles.featureBlockImg}>
                {icon}
            </div>
            <h3 className={styles.featureBlockTitle}>{title}</h3>
            <p className={styles.featureBlockDescription}>{description}</p>
        </div>
    );
}

export default FeatureBlock;